export const PACKING_DONE_REQUEST = "PACKING_DONE_REQUEST";
export const PACKING_DONE_SUCCESS = "PACKING_DONE_SUCCESS";
export const PACKING_DONE_FAIL = "PACKING_DONE_FAIL";